import { useState, useEffect, useRef } from "react";
import {
  Container,
  Navbar,
  Row,
  Col,
  Nav,
  Dropdown,
  Button,
  Modal,
} from "react-bootstrap";
import "../Utils/assets/css/header.css";
import "../Utils/assets/css/custom.css";
import "../Utils/assets/css/styles.css";
import "../Utils/assets/css/icons.css";
import "../Utils/assets/css/icons.min.css";
import favicon from '../Utils/assets/img/pugCrm_favicon.png';
import puglogo from '../Utils/assets/img/pugcrm_logo.png';
import useLocalStorageState from "use-local-storage-state";
import { UpdateRF } from "../Utils/hooks/ApiHandler";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { baseURL, defaultImage, imageURL } from "../Utils/constants/constant";
import { CreateDeal } from "../Components/deals/CreateDeal";
import { Tasks } from "../Components/Forms/Tasks";
import { Meetings } from "../Components/detailPage/leads/Meetings";
import { CreateCompany } from './../pages/CreateCompany';
import { CreateLead } from './../Components/Leads/CreateLead';
import Tooltip from "@mui/material/Tooltip";
import ProfileOffCanvas from '../Profile/ProfileOffcanvas';
import { toast } from "sonner";
import { ContactForm } from "../Components/education/Contacts/ContactModule/ContactForm";
import { useQueryClient } from "react-query";
import { getCountries } from "../Utils/hooks/location";
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler";
const mockResults = [
  {
    id: 1,
    label: "[Sample] Tony Turner",
    sub: "Rs30,000 · [Sample] MoveEr · Contact Made",
  },
  {
    id: 2,
    label: "[Sample] Tony Tuner",
    sub: "Rs10,000 · [Sample] Buyer · Meeting Scheduled",
  },
];

const highlightMatch = (text, query) => {
  const parts = text.split(new RegExp(`(${query})`, "gi"));
  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={index}>{part}</mark>
    ) : (
      part
    )
  );
};

const Header = ({ toggleSidebar, isOpen, isHovered }) => {
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [showProfileCanvas, setShowProfileCanvas] = useState(false);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const queryClient = useQueryClient()

  // State for various offcanvas components
  const [openContactOffcanvas, setOpenContactOffcanvas] = useState(false);
  const [openCompanyOffcanvas, setOpenCompanyOffcanvas] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [openDealOffcanvas, setOpenDealOffcanvas] = useState(false);
  const [openLeadOffcanvas, setOpenLeadOffcanvas] = useState(false);
  const [openTaskOffcanvas, setOpenTaskOffcanvas] = useState(false);
  const [openMeetings, setOpenMeetings] = useState(false);

  const location = useLocation();
  const [customer, setCustomer] = useLocalStorageState("customer");

  const permission = customer.customer_details?.permission;
  const user_type = Number(customer.customer_details?.user_type);
  const contactCreate = user_type !== 1 ? Boolean(permission?.filter(c => c.feature_name === "contact")[0]?.create) : true
  const dealCreate = user_type !== 1 ? Boolean(permission?.filter(c => c.feature_name === "deals")[0]?.create) : true
  const leadCreate = user_type !== 1 ? Boolean(permission?.filter(c => c.feature_name === "leads")[0]?.create) : true
  const companyCreate = user_type !== 1 ? Boolean(permission?.filter(c => c.feature_name === "company")[0]?.create) : true
  const quotationCreate = user_type !== 1 ? Boolean(permission?.filter(c => c.feature_name === "quotation")[0]?.create) : true
  const isQuotation = Boolean(permission?.find(c => c.module_name === "quotation"))

  const dashboardPermission = permission?.filter(c => c.module_name === "dashboard")
  const inboxView = user_type !== 1 ? Boolean(Number(dashboardPermission?.filter(c => c.feature_name === "inbox")[0]?.view)) : true
  const projectView = user_type !== 1 ? Boolean(Number(dashboardPermission?.filter(c => c.feature_name === "project")[0]?.view)) : true

  // Search handlers
  const handleClick = () => {
    if (query.trim() === "") {
      setShowDropdown(false);
    }
  };

  const handleFocus = () => {
    if (query.trim() === "") {
      setShowDropdown(false);
    } else {
      setShowDropdown(true);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim() === "") {
      setShowDropdown(false);
    } else {
      setShowDropdown(true);
    }
  };

  const filteredResults = query
    ? mockResults.filter((r) =>
      r.label.toLowerCase().includes(query.toLowerCase())
    )
    : [];

  useEffect(() => {
    const inputs = document.querySelectorAll(".custom-control-input");
    const icons = document.querySelectorAll(".customIcons");

    inputs.forEach((input) => {
      input.style.display = showInputs ? "inline-block" : "none";
    });

    icons.forEach((icon) => {
      icon.style.display = showInputs ? "none" : "inline-block";
    });
  }, [showInputs]);

  const handleToggle = () => {
    setShowInputs((prev) => !prev);
  };
  // outside click custom hook
  useOutsideClickHandler({
    objRef: wrapperRef,
    isDropdown: showDropdown,
    setDropdown: setShowDropdown
  })

  // Tooltip styles
  const tooltipStyles = {
    tooltip: {
      sx: {
        fontSize: '0.8rem',
        backgroundColor: "#7a3a5e",
        color: "white",
      }
    },
    arrow: {
      sx: {
        color: "#7a3a5e",
      }
    }
  };

  // Profile dropdown content component
  const ProfileDropdownContent = () => (
    <>
      <div className="ps-4 headerDropdowns" style={{ padding: "2px", gap: "15px", height: '7rem', }}>
        <p style={{ color: "#2e384d" }} className="mb-0">
          <span style={{ fontWeight: 600, fontSize: "1rem", textTransform: 'capitalize' }}>
            {customer?.customer_details?.first_name + " " + customer?.customer_details?.last_name}{" "}
          </span>
          <span style={{ display: "flex", alignItems: "center", color: "#687790", fontSize: "0.8rem" }}>
            {customer?.customer_details?.email}
          </span>
          <span style={{ display: "flex", alignItems: "center", color: "#232e41", fontSize: "0.8rem" }}>
            {customer?.customer_details?.role_title}
          </span>
        </p>
        <p className="userNameIcon mb-0 d-flex justify-content-center align-items-center">
          <span style={{ fontSize: '1.1rem' }}>
            {`${customer?.customer_details?.first_name?.charAt(0).toUpperCase() ?? ''}${customer?.customer_details?.last_name?.charAt(0).toUpperCase() ?? ''}`}
          </span>
        </p>
      </div>


      <Dropdown.Item
        onClick={() => setShowProfileCanvas(true)}
        className="d-flex align-items-center mt-3"
      >
        <i className="fa-solid fa-circle-user fs-18 me-2"></i>My Profile
      </Dropdown.Item>
      <Dropdown.Item className="d-flex align-items-center" onClick={() => navigate("/setup/companyDetails")} data-bs-toggle="modal" data-bs-target="#issueRaise">
        <i className="fa-solid fa-gear fs-18 me-2"></i>Crm Setup
      </Dropdown.Item>
      <Dropdown.Item className="d-flex align-items-center" onClick={() => navigate("/subscriptiondetails")}>
        <i className="fa-solid fa-circle-dollar-to-slot fs-18 me-2"></i>
        Crm Subscription
      </Dropdown.Item>
      <Dropdown.Item className="d-flex align-items-center">
        <i className="fa-solid fa-lock fs-18 me-2"></i>
        <Link to="/changePassword" style={{ textDecoration: 'none', color: 'inherit' }}>Change Password</Link>
      </Dropdown.Item>
      {isSmallScreen && (
        <>
          <Dropdown.Item onClick={() => {
            if (!projectView) {
              toast.warning("You are not authorized for this action!")
              return
            }
            navigate('/ProjectDashboard')
          }} className="d-flex align-items-center">
            <i className="fa-solid fa-layer-group fs-18 me-2"></i>Projects
          </Dropdown.Item>
          <Dropdown.Item onClick={() => {
            if (!inboxView) {
              toast.warning("You are not authorized for this action!")
              return
            }
            navigate('/testing')
          }} className="d-flex align-items-center">
            <i className="fa-solid fa-envelope fs-18 me-2"></i>Inbox
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setOpenLeadOffcanvas(true)} className="d-flex align-items-center">
            <i className="fa-solid fa-square-plus fs-18 me-2"></i>Create
          </Dropdown.Item>
        </>
      )}
      <Dropdown.Item className="d-flex mb-3" onClick={() => {
        UpdateRF(customer.token?.authentication);
        queryClient.clear();
        setCustomer({
          customer_details: {},
          customer_status: "Inactive",
          user_login: false,
          token: {},
        });
      }}>
        <i className="fa-solid fa-right-from-bracket fs-18 me-2"></i>
        <Link to="/login" style={{ textDecoration: 'none', color: 'inherit' }}>
          Log Out
        </Link>
      </Dropdown.Item>
    </>
  );

  // Profile avatar component
  const ProfileAvatar = () => (
    <div className="d-flex align-items-center gap-2">
      {customer?.customer_details?.profile_img !== null ? (
        <div
          className="rounded-circle overflow-hidden border border-3"
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "#f0f0f0",
            borderColor: "#7a3a5e",
            fontSize: '13px',
            position: "fixed",
            right: "1rem",
            top: "0.5rem"
          }}
        >
          <img
            src={
              customer?.customer_details?.outh_provider === "google"
                ? customer?.customer_details?.profile_img
                : `${imageURL}${customer?.customer_details?.profile_img}`
            }
            alt="Profile"
            onError={(e) => {
              e.target.src = defaultImage;
            }}
            className="w-100 h-100 object-fit-cover"
          />
        </div>
      ) : (
        <div
          className="rounded-circle overflow-hidden border border-0 d-flex justify-content-center align-items-center"
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "#e5f0fe",
            color: "#2e384d",
          }}
        >
          {`${customer?.customer_details?.first_name?.charAt(0).toUpperCase() ?? ''}${customer?.customer_details?.last_name?.charAt(0).toUpperCase() ?? ''}`}
        </div>
      )}
    </div>
  );

  // Search component
  const SearchComponent = () => (
    <div
      className="searchInputDiv"
      ref={wrapperRef}
      style={{
        position: isSmallScreen ? "fixed" : "relative",
        top: isSmallScreen ? "8px" : "auto",
        left: isSmallScreen ? "23rem" : "auto",
        width: isSmallScreen ? "30%" : "295px",
        zIndex: 2000,
      }}
    >
      <i
        className="fa-solid fa-magnifying-glass"
        style={{
          paddingLeft: "17px",
          marginTop: "11px",
          marginBottom: "11px",
          position: "absolute",
        }}
      ></i>

      <input
        type="search"
        className="form-control pe-1"
        value={query}
        style={{
          border: 0,
          width: "295px",
          height: "36px",
          paddingLeft: "50px",
          borderRadius: "21px !important",
          boxShadow: "none",
        }}
        placeholder="Search across Leads, Deals and more..."
        onChange={handleChange}
        onFocus={handleFocus}
        onClick={handleClick}
      />

      {showDropdown && filteredResults.length > 0 && (
        <Row className="dropdown-results d-flex">
          <Col md={3} className="search-entities-list">
            <div className="heading">
              <div className="fs-13 d-flex align-items-center gap-2" onClick={handleToggle}>
                <i className="fa-solid fa-gear fs-16"></i> All Categories
              </div>
            </div>
            <ul className="list-group list-group-flush checkbox-list ps-1">
              {['Leads', 'Contact', 'Company', 'Deals'].map((item, index) => (
                <li className="list-group-item" key={index}>
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="from-check-input custom-control-input"
                      style={{ display: "none" }}
                    />
                    <i
                      className={`fa-solid ${index === 0 ? 'fa-user' : index === 1 ? 'fa-image-portrait' : index === 2 ? 'bx bxs-business' : 'fa-sack-dollar'} fs-17 customIcons`}
                      style={{ color: "#687790" }}
                    ></i>
                    <label htmlFor="LEAD" className="ms-2 custom-control-label">
                      {item}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
          <Col md={8}>
            <p
              className="heading"
              style={{
                marginTop: "12px",
                borderBottom: "1px solid #DFDFDF",
                paddingBottom: "11px",
                fontSize: "13px",
                color: "#5d5d5d",
              }}
            >
              Search results for deals
            </p>
            {filteredResults.map((result) => (
              <div key={result.id} className="dropdown-item">
                <strong>{highlightMatch(result.label, query)}</strong>
                <div className="dropdown-sub">
                  {highlightMatch(result.sub, query)}
                </div>
              </div>
            ))}
          </Col>
        </Row>
      )}
    </div>
  );

  // Desktop navigation icons
  const DesktopNavigationIcons = () => (
    <>
      <Tooltip title="Projects" arrow placement="bottom" componentsProps={tooltipStyles}>
        <Nav.Link onClick={() => {
          if (!projectView) {
            toast.warning("You are not authorized for this action!")
            return
          }
          navigate('/ProjectDashboard')
        }} style={{ padding: "5px" }}>
          <i className="fa-solid fa-layer-group header-link-icon d-flex justify-content-center" style={{ color: "#2e384e", fontSize: "1rem" }}></i>
        </Nav.Link>
      </Tooltip>

      <Tooltip title="Inbox" arrow placement="bottom" componentsProps={tooltipStyles}>
        <Nav.Link onClick={() => {
          if (!inboxView) {
            toast.warning("You are not authorized to view Inbox!")
            return
          }
          navigate('/testing')
        }} style={{ padding: "0px" }}>
          <i className="fa-solid fa-envelope header-link-icon d-flex justify-content-center" style={{ color: "#2e384e", fontSize: "1rem" }}></i>
        </Nav.Link>
      </Tooltip>

      <Dropdown as="div" className="cart-dropdown header-element">
        <Tooltip title="Create" arrow placement="bottom" componentsProps={tooltipStyles}>
          <Dropdown.Toggle as={Nav.Link} style={{ padding: "0px 3px 0px 3px" }}>
            <i className="fa-solid fa-square-plus header-link-icon" style={{ color: "#2e384d", fontSize: "1rem" }}></i>
          </Dropdown.Toggle>
        </Tooltip>
        <Dropdown.Menu className="main-header-dropdown header-profile-dropdown plusDrowpdown dropdown-menu-end">
          <CreateDropdownContent />
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown as="div" className="header-element cart-dropdown">
        <Tooltip title="My Apps" arrow placement="bottom" componentsProps={tooltipStyles}>
          <Dropdown.Toggle as={Nav.Link} className="header-link" style={{ padding: 0 }}>
            <i className="bx bxs-extension" style={{ color: "#2e384d", fontSize: "1rem", paddingBottom: "3px" }}></i>
          </Dropdown.Toggle>
        </Tooltip>
      </Dropdown>

      <div className="header-element cart-dropdown">
        <Tooltip title="Task" arrow placement="bottom" componentsProps={tooltipStyles}>
          <Nav.Link href="##" style={{ padding: 0 }}>
            <i className="fa-solid fa-question header-link-icon d-flex justify-content-center" style={{ fontSize: "1rem" }}></i>
          </Nav.Link>
        </Tooltip>
      </div>

      <Dropdown as="div" className="header-element notifications-dropdown">
        <Tooltip title="Ticket" arrow placement="bottom" componentsProps={tooltipStyles}>
          <Dropdown.Toggle as={Nav.Link} className="header-link" style={{ padding: 0 }}>
            <i className="fa-solid fa-bell header-link-icon" style={{ color: "#2e384d", fontSize: "1rem" }}></i>
          </Dropdown.Toggle>
        </Tooltip>
        <NotificationsDropdown />
      </Dropdown>
    </>
  );

  // Create dropdown content
  const CreateDropdownContent = () => (
    <>
      <label className="app__global-label">Records</label>
      <Row className="mt-2 w-100">
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => {
            if (!leadCreate) {
              toast.warning("You are not authorized for this action!")
              return
            }
            setOpenLeadOffcanvas(true)
          }}>
            <i className="fa-solid fa-user fs-14 me-2"></i>Add Lead
          </Dropdown.Item>
        </Col>
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => {
            if (!contactCreate) {
              toast.warning("You are not authorized for this action!")
              return
            }
            setOpenContactOffcanvas(true)
          }}>
            <i className="fa-solid fa-address-book fs-14 me-2"></i>Add Contact
          </Dropdown.Item>
        </Col>
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => {
            if (!companyCreate) {
              toast.warning("You are not authorized for this action!")
              return
            }
            setOpenCompanyOffcanvas(true)
          }
          }
          >
            <i className="bx bxs-buildings fs-14 me-2"></i>Add Company
          </Dropdown.Item>
        </Col>
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => {
            if (!dealCreate) {
              toast.warning("You are not authorized for this action!")
              return
            }
            setOpenDealOffcanvas(true)
          }}>
            <i className="fa-solid fa-sack-dollar fs-14 me-2"></i>Add Deals
          </Dropdown.Item>
        </Col>
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => {
            if (!quotationCreate || !isQuotation) {
              if (!quotationCreate) {
                toast.warning("You are not authorized for this action!")
              } else {
                toast.warning("Upgrade your plan to create Quotation!")
              }
              return
            }
            navigate('/createquotation')
          }}>
            <i className="fa-solid fa-file-invoice fs-14 me-2"></i>Add Quotation
          </Dropdown.Item>
        </Col>
      </Row>
      <hr style={{ borderColor: "#E0E4F8 !important" }} />
      <label className="app__global-label">Activities</label>
      <Row className="mt-2 w-100">
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => setOpenTaskOffcanvas(true)}>
            <i className="fa-solid fa-square-check fs-14 me-2"></i>Add Task
          </Dropdown.Item>
        </Col>
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center" onClick={() => setOpenMeetings(true)}>
            <i className="fa-solid fa-calendar fs-14 me-2"></i>Add Meeting
          </Dropdown.Item>
        </Col>
      </Row>
      <hr style={{ borderColor: "#E0E4F8 !important" }} />
      <label className="app__global-label">Insights</label>
      <Row className="mt-2 w-100">
        <Col md={12}>
          <Dropdown.Item className="d-flex align-items-center">
            <i className="fa-solid fa-chart-pie fs-14 me-2"></i>Create Report
          </Dropdown.Item>
        </Col>
      </Row>
    </>
  );

  // Notifications dropdown
  const NotificationsDropdown = () => (
    <Dropdown.Menu className="main-header-dropdown header-profile-dropdown dropdown-menu-end">
      <div className="ps-3 p-2">
        <p className="mb-0 fs-17 fw-semibold">Support Ticket</p>
      </div>
      <Dropdown.Divider />
      <ul className="list-unstyled mb-0" id="header-notification-scroll">
        {[...Array(5)].map((_, i) => (
          <Dropdown.Item as="li" style={{ height: "auto" }} key={i}>
            <div className="d-flex align-items-start">
              <div className="pe-2">
                <Nav.Link href="##">
                  <span className="avatar avatar-md bg-primary avatar-rounded">
                    <i className="bx bxs-bell-ring fs-18"></i>
                  </span>
                </Nav.Link>
              </div>
              <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-0 fw-semibold">
                    <Nav.Link href="##">
                      from today morning my assets mana...
                    </Nav.Link>
                  </p>
                  <span className="text-muted fw-normal fs-12 header-notification-text">
                    20-12-2024 06:15 PM
                  </span>
                </div>
              </div>
            </div>
          </Dropdown.Item>
        ))}
      </ul>
      <div className="p-3 row border-top">
        <div className="col-sm float-start">
          <Button variant="outline-primary" size="sm">Add New Ticket</Button>
        </div>
        <div className="col-sm">
          <Button variant="primary" size="sm" className="float-end" href="##">
            View All Tickets
          </Button>
        </div>
      </div>
    </Dropdown.Menu>
  );

  return (
    <Navbar expand="lg" className="app-header p-0" style={{ position: 'fixed', top: 0 }}>
      <Container fluid className="main-header-container p-0">
        {/* Left Section */}
        <div className="header-content-left d-flex align-items-center" style={{ borderRight: '1px solid #e6e6e6', height: '4rem' }}>
          <div className="main-sidebar-header" style={{ width: '3.5rem' }}>
            <Dropdown as="div" className="header-element cart-dropdown">
              <Dropdown.Toggle as={Nav.Link} className="header-logo d-flex justify-content-center">
                <img src={favicon} alt="logo" className="desktop-logo" style={{ width: '50%' }} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="main-header-dropdown header-profile-dropdown dropdown-menu-start" style={{ left: '12px', top: '3.2rem !important', width: 'auto', minWidth: '12rem' }}>
                <Dropdown.Item href="##" className="d-flex align-items-center">

                  <i className="fa-solid fa-circle-user fs-18 me-2"></i>My Profile
                </Dropdown.Item>
                <Dropdown.Item className="d-flex align-items-center" onClick={() => navigate("/setup/companyDetails")} data-bs-toggle="modal" data-bs-target="#issueRaise">
                  <i className="fa-solid fa-gear fs-18 me-2"></i>Crm Setup
                </Dropdown.Item>
                <hr style={{ borderColor: '#c2c2c6' }} />
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <img src={puglogo} alt="" style={{ width: '100px' }} />
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* Main Header Content */}
        <div className="header-main-content d-flex align-items-center justify-content-between w-100 px-3">
          {/* Search - Centered */}
          <div className="header-search flex-grow-1 d-flex justify-content-center">
            <SearchComponent />
          </div>

          {/* Right Icons */}
          <div className="header-right-icons flex-shrink-0" style={{ top: "0.5rem", right: "1rem", position: "fixed" }}>
            <Nav className="d-flex align-items-center gap-2" style={{ marginRight: "1.3rem" }}>
              {!isSmallScreen && <DesktopNavigationIcons />}

              {/* Profile - Always visible */}
              <Dropdown as="div" className="header-element" style={{ top: `${isSmallScreen ? "3.8rem" : 0}` }}>
                <Dropdown.Toggle as={Nav.Link} className="header-link">
                  <ProfileAvatar />
                </Dropdown.Toggle>
                <Dropdown.Menu className="profileDropdownMainDiv main-header-dropdown header-profile-dropdown dropdown-menu-end" style={{ right: `${isSmallScreen ? "3.4rem" : 0}`, top: "-3px" }}>
                  <ProfileDropdownContent />
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </div>
        </div>
      </Container>
      <style jsx>
        {`
          .main-header-dropdown.header-profile-dropdown.dropdown-menu-end.dropdown-menu.show::before {
            content: "";
            position: absolute;
            bottom: ${isSmallScreen ? "99.5%" : "100%"};
            right: 0.5rem;
            border-left: 0.5rem solid transparent;
            border-right: 0.5rem solid transparent;
            border-bottom: 0.5rem solid #fff;
          }
        `}
      </style>
      {/* Offcanvas Components */}
      <OffcanvasComponents
        openContactOffcanvas={openContactOffcanvas}
        setOpenContactOffcanvas={setOpenContactOffcanvas}
        openDealOffcanvas={openDealOffcanvas}
        setOpenDealOffcanvas={setOpenDealOffcanvas}
        openTaskOffcanvas={openTaskOffcanvas}
        setOpenTaskOffcanvas={setOpenTaskOffcanvas}
        openLeadOffcanvas={openLeadOffcanvas}
        setOpenLeadOffcanvas={setOpenLeadOffcanvas}
        openMeetings={openMeetings}
        setOpenMeetings={setOpenMeetings}
        openCompanyOffcanvas={openCompanyOffcanvas}
        setOpenCompanyOffcanvas={setOpenCompanyOffcanvas}
        setReloadKey={setReloadKey}
      />
      {showProfileCanvas && (<ProfileOffCanvas
        show={showProfileCanvas}
        handleClose={() => setShowProfileCanvas(false)}
      />)}
    </Navbar >
  );
};

// Separate component for offcanvas components to clean up main return
const OffcanvasComponents = ({
  openContactOffcanvas,
  setOpenContactOffcanvas,
  openDealOffcanvas,
  setOpenDealOffcanvas,
  openTaskOffcanvas,
  setOpenTaskOffcanvas,
  openLeadOffcanvas,
  setOpenLeadOffcanvas,
  openMeetings,
  setOpenMeetings,
  openCompanyOffcanvas,
  setOpenCompanyOffcanvas,
  setReloadKey
}) => {

  const [customer, setCustomer] = useLocalStorageState('customer')

  // country state for contact form
  const [country, setCountries] = useState([{ countryName: "", countryId: 0 }])

  const permission = customer.customer_details?.permission;
  const user_type = Number(customer.customer_details?.user_type);
  const leadSourcePermission = permission?.filter(
    (c) => c.module_name === "setting",
  )
  // company permissions while creating contact
  const companyPermission = permission?.filter(c => c.module_name === "company")
  const companyGrants = {
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.create)) : true,
  }
  const masterGrant = {
    isCreate:
      user_type !== 1
        ? Boolean(
          Number(
            leadSourcePermission?.find((c) => c.feature_name === "master")
              ?.create,
          ),
        )
        : true,
  }

  // Fetch countries when component mounts
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getCountries()
        if (data) {
          setCountries(
            data.map((c) => ({
              countryName: c.name,
              countryId: c.id,
            })),
          )
        }
      } catch (err) {
        return
      }
    }
    if (openContactOffcanvas) {
      fetchCountries()
    }
  }, [openContactOffcanvas])

  return <>
    {openContactOffcanvas && (
      <ContactForm
        show={openContactOffcanvas}
        setShow={setOpenContactOffcanvas}
        companyGrants={companyGrants}
        country={country}
        masterGrant={masterGrant}
      />
    )}

    {openDealOffcanvas && (
      <CreateDeal show={openDealOffcanvas} onHide={() => setOpenDealOffcanvas(false)} moduleName="deals" />
    )}

    {openTaskOffcanvas && (
      <Tasks show={openTaskOffcanvas} onCanvasClose={() => setOpenTaskOffcanvas(false)} contactId="0" />
    )}

    {openLeadOffcanvas && (
      <CreateLead show={openLeadOffcanvas} onHide={() => setOpenLeadOffcanvas(false)} module_name='leads' />
    )}

    {openMeetings && (
      <Modal show={openMeetings} onHide={() => setOpenMeetings(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Meetings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Meetings />
        </Modal.Body>
      </Modal>
    )}

    {openCompanyOffcanvas && (
      <CreateCompany setReloadKey={setReloadKey} show={openCompanyOffcanvas} setShow={setOpenCompanyOffcanvas} />
    )}

  </>
};

export default Header;